@use "styles/abstracts/variables" as v;
@use "styles/abstracts/mixins/typography" as t;
@use "styles/abstracts/mixins/common" as c;

%button-z-index {
  z-index: 2;
}

.card {
  box-shadow: v.$shadow-2;
  background: v.$palette-white;
  color: v.$palette-gray-900;
  border-radius: 6px;
  padding: 14px 16px;
  min-height: 136px;

  &.hasOnOpenHandler {
    position: relative;
  }
}

.selectWidth {
  width: 347px;
}

.row {
  display: flex;
  align-items: baseline;

  .leftShift {
    margin-left: auto;
  }

  .rightShift {
    margin-right: auto;
  }
}

.header {
  align-items: center;
  justify-content: space-between;
  @include c.containerMedia(v.$tablet-breakpoint) {
    flex-wrap: wrap;
      row-gap: 10px;
  }

  .updateContainer {
    display: flex;
  }
}

.footer {
  flex-wrap: wrap;
  row-gap: 10px;
  justify-content: space-between;
}

.scacImg {
  width: 24px;
  height: 24px;
  margin-right: 5px;
  border-radius: 4px;
}

.referenceType {
  color: v.$palette-gray-900;
  @include t.text(14px, 22px, 600);
}
.containerId {
  margin-left: 5px;
  @include t.text(14px, 22px, 600);
}
.containerStatus {
  margin-left: 9px;

  &.is-clickable {
    @extend %button-z-index;
  }
}

.directions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 13px;
}
.direction {
  @include t.text(16px, 18px, 600);
}

.dateBox {
  margin-right: auto;
  display: flex;
  align-items: center;
  @include t.text(12px, 20px, 500);
  margin-right: 10px;

  .date + .date {
    margin-left: 16px;
  }

  .dateWithTooltip {
    cursor: pointer;
  }
}

.tooltipDateText {
  background-color: v.$palette-gray-900;
  position: relative;
  color: v.$palette-white;
  padding: 8px 16px;
  border-radius: 6px;
  @include t.text(14px, 22px, 400);
  max-width: 245px;

  &::after {
    content: "";
    left: calc(50% - 5px);
    bottom: -7px;
    position: absolute;
    background-color: v.$palette-gray-900;
    width: 15px;
    height: 15px;
    border-radius: 2px;
    rotate: 135deg;
  }
}


.buttonBox {
  display: flex;

  .button + .button {
    margin-left: 8px;
  }
}
.button {
  @extend %button-z-index;

  &.follow {
    @include t.text(14px, 22px, 500);
    padding: 5px 14px;
  }

  &.delete,
  &.open {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    width: 32px;
    height: 32px;
    background-color: v.$palette-blue-light-2;
    transition: .2s;

    &:hover {
      transition: .2s;
      background-color: unset;
    }
  }

  &.delete svg {
    path {
      fill: v.$palette-blue;
    }
  }

  &.open svg {
    path {
      stroke: v.$palette-blue;
    }
  }

  &-loading {
    color: grey;
    cursor: progress;
    user-select: none;
  }
}

.overlayOpener {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  cursor: pointer;
  z-index: 1;
}

.tooltipCarrierName {
  background-color: v.$palette-gray-900;
  position: relative;
  color: v.$palette-white;
  padding: 8px 16px;
  border-radius: 6px;
  @include t.text(14px, 22px, 400);
  min-width: 100px;
  max-width: 320px;
  text-align: center;

  &::after {
    content: "";
    left: 17px;
    bottom: -7px;
    position: absolute;
    background-color: v.$palette-gray-900;
    width: 15px;
    height: 15px;
    border-radius: 2px;
    rotate: 135deg;
  }
}

.tooltipTagsName {
  background-color: v.$palette-gray-900;
  position: relative;
  color: v.$palette-white;
  padding: 8px 16px;
  border-radius: 6px;
  @include t.text(14px, 22px, 400);

  &::after {
    content: "";
    left: calc(50% - 7px);
    bottom: -7px;
    position: absolute;
    background-color: v.$palette-gray-900;
    width: 15px;
    height: 15px;
    border-radius: 2px;
    rotate: 135deg;
  }
}

.tagsWrap {
  margin-left: 4px;
  cursor: pointer;
  padding: 2px 10px;
  border-radius: 24px;
  @include t.text(12px, 20px, 500);

  &.air {
    background-color: v.$palette-red-light-2;
    color: v.$palette-red;
  }

  &.sea {
    background-color: v.$palette-blue-light-2;
    color: v.$palette-blue;
  }
}

.pieces {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 2px 10px;
  background-color: v.$palette-red-light-2;
  border-radius: 24px;
  color: v.$palette-red;
  @include t.text(12px, 20px, 500);
}

.piecesIcon {
  path {
    fill: v.$palette-red;
  }
}

.countBox {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: v.$palette-gray-200;
  padding: 4px 10px;
  border-radius: 24px;
  gap: 8px;
}
.count {
  @include t.text(10px, 14px, 600);
  color: v.$palette-gray-900;
}